(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ba-localization"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-ba-language]');
    if (!choice) return;
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const next = new URL(choice.href, window.location.origin);
    if (next.origin !== window.location.origin) return;
    event.preventDefault();
    next.search = window.location.search;
    next.hash = window.location.hash;
    window.location.assign(next.href);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ba-policy-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ba-policy-dialog')) {
    customElements.define('ba-policy-dialog', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const root = this.closest('.ba-pinfo');
        if (!root) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        root.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-ba-policy-open]');
          if (!trigger || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const dialog = this.querySelector('[data-ba-policy-content="' + trigger.dataset.baPolicyOpen + '"]');
          if (!dialog || typeof dialog.showModal !== 'function') return;
          event.preventDefault();
          this.opener = trigger;
          dialog.showModal();
          document.documentElement.classList.add('ba-policy-open');
          dialog.querySelector('.ba-policy__body').scrollTop = 0;
          dialog.querySelector('.ba-policy__full').open = false;
        }, options);
        this.querySelectorAll('dialog').forEach((dialog) => {
          dialog.addEventListener('click', (event) => {
            if (event.target.closest('[data-ba-policy-close]')) dialog.close();
            else if (event.target === dialog) {
              const bounds = dialog.getBoundingClientRect();
              if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
            }
          }, options);
          dialog.addEventListener('close', () => {
            if (!document.querySelector('.ba-policy[open]')) document.documentElement.classList.remove('ba-policy-open');
            if (this.opener && this.opener.isConnected) this.opener.focus({ preventScroll: true });
          }, options);
        });
      }
      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = null;
        if (!document.querySelector('.ba-policy[open]')) document.documentElement.classList.remove('ba-policy-open');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
